import { type HttpClient } from '@/application/interfaces/http-client';

import { postPagarmeCheckCard } from './post-pagarme-check-card';
import { postPayment } from './post-payment';

const paymentService = (httpClient: HttpClient.Instance) => ({
  postPagarmeCheckCard: postPagarmeCheckCard(httpClient),
  postPayment: postPayment(httpClient),
});

export default paymentService;
